import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

const { carbon } = colorsPalettes;
const { setFontVariant } = mixins;

export const Title = styled.div`
    ${setFontVariant("h5", carbon[500])}
`;
